const getMatchingOptionsFromImageIndex = optionsMapping => position => {
  const matches = optionsMapping.filter(variant => (variant.imagePosition === position))
  return matches;
}

export default getMatchingOptionsFromImageIndex